import type { AppRouteRecordRaw } from "#src/router/types";

/** Sort routes in ascending order of 'order' property */
export function ascending(arr: AppRouteRecordRaw[]) {
	return arr.map((routeItem, routeIndex) => ({
		...routeItem,
		handle: {
			...routeItem.handle,
			// Automatically create 'order' if it does not exist, based on the array index
			order: routeItem?.handle?.order || routeIndex + 2,
		},
	})).sort(
		(a, b) => {
			return a?.handle?.order - b?.handle?.order;
		},
	);
}
